import Vue from 'vue';

export default Vue.extend({
  name: 'C変換枚数',

  props: {
    ym: {
      type: Number,
      required: true,
    },
    denominator: {
      type: Number,
      required: true,
    },
    numerator: {
      type: Number,
      required: true,
    },
  },
});
